/**
 * 接口地址的统一管理
 */
const base = {
  url: process.env.VUE_APP_BASE_API,
  url_im: process.env.VUE_APP_BASE_API
};
export default {
  //白名单查询
  account: {
    realQuery: `${base.url}/trade/realAccount/list`,
    demoQuery: `${base.url}/trade/demoAccount/demoList`,
  },
  balance:{
    realAdjustment:{
      query:`${base.url}/trade/realBalanceAdjust/list`,
      addProposal:`${base.url}/trade/realBalanceAdjust/addProposal`,
      cancelProposal:`${base.url}/trade/realBalanceAdjust/cancelProposal`,
      approveProposal:`${base.url}/trade/realBalanceAdjust/approveProposal`,
    },
    demoAdjustment:{
      query:`${base.url}/trade/demoBalanceAdjust/list`,
      addProposal:`${base.url}/trade/demoBalanceAdjust/addProposal`,
      cancelProposal:`${base.url}/trade/demoBalanceAdjust/cancelProposal`,
      approveProposal:`${base.url}/trade/demoBalanceAdjust/approveProposal`,
    },
    balanceRecord:{
      realQuery: `${base.url}/trade/realBalanceRecord/list`,
      demoQuery: `${base.url}/trade/demoBalanceRecord/list`,
    },
    balance:{
      realQuery: `${base.url}/trade/realAccountBalance/realList`,
      demoQuery: `${base.url}/trade/demoAccountBalance/demoList`,
    }
  },
  demoOrder:{
    demoOrderQuery: `${base.url}/trade/demoOrder/queryOrderListPage`,
  },
  realOrder:{
    realOrderQuery: `${base.url}/trade/realOrder/queryOrderListPage`,
  },
  tradeConfig:{
    product:{
      productQueryList: `${base.url}/trade/product/queryProductListPage`,
      productAdd: `${base.url}/trade/product/addProduct`,
      productUpdate: `${base.url}/trade/product/updateProduct`,
      productDelete: `${base.url}/trade/product/deleteProduct`
    },
    tradeTime:{
      tradeTimeQueryList: `${base.url}/trade/tradeTime/queryUnionTradeTimeListPage`,
      tradeTimeAdd: `${base.url}/trade/tradeTime/addTradeTime`,
      tradeTimeUpdate: `${base.url}/trade/tradeTime/updateTradeTime`,
      tradeTimeDelete: `${base.url}/trade/tradeTime/deleteTradeTime`,
      productAllList: `${base.url}/trade/product/queryProductList`
    },
    tradeMarket:{
      marketConfigQueryList: `${base.url}/trade/marketConfig/queryUnionMarketConfigListPage`,
      marketConfigAdd: `${base.url}/trade/marketConfig/addMarketConfig`,
      marketConfigUpdate: `${base.url}/trade/marketConfig/updateMarketConfig`,
      marketConfigDelete: `${base.url}/trade/marketConfig/deleteMarketConfig`,
      productAllList: `${base.url}/trade/product/queryProductList`
    },
    holidayConfig:{
      holidayConfigQueryList: `${base.url}/trade/holidayConfig/queryHolidayConfigListPage`,
      holidayConfigAdd: `${base.url}/trade/holidayConfig/addHolidayConfig`,
      holidayConfigUpdate: `${base.url}/trade/holidayConfig/updateHolidayConfig`,
      holidayConfigDelete: `${base.url}/trade/holidayConfig/deleteHolidayConfig`,
      productAllList: `${base.url}/trade/product/queryProductList`
    },
    tradeConfig:{
      tradeConfigQueryList: `${base.url}/trade/tradeConfig/queryTradeConfigListPage`,
      tradeConfigAdd: `${base.url}/trade/tradeConfig/addTradeConfig`,
      tradeConfigUpdate: `${base.url}/trade/tradeConfig/updateTradeConfig`,
      tradeConfigDelete: `${base.url}/trade/tradeConfig/deleteTradeConfig`,
      productAllList: `${base.url}/trade/product/queryProductList`
    }
  }
};


